import * as React from 'react';

export const QuestionNodesContext = React.createContext<object[]>([]);
export const QuestionsContext = React.createContext<object>({});
export const AnswersContext = React.createContext<object>({});
